
const digest = '5d3c0ee10b0388d76087cf5062a2f80e6a22fb399c68767764986bccaa63cff7';
const classes = {"wrapper":"_wrapper_h25l6_1","title":"_title_h25l6_13","invoice":"_invoice_h25l6_17","name":"_name_h25l6_23","rightPart":"_rightPart_h25l6_27","amount":"_amount_h25l6_30","canceled":"_canceled_h25l6_36"};
const css = `._wrapper_h25l6_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  box-shadow: 0px 3px 5px 0 rgba(68, 70, 105, 0.15);
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 15px;
}
._wrapper_h25l6_1 ._title_h25l6_13 {
  font-size: 16px;
  font-weight: 600;
}
._wrapper_h25l6_1 ._invoice_h25l6_17 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
._wrapper_h25l6_1 ._invoice_h25l6_17 ._name_h25l6_23 {
  font-size: 14px;
  font-family: Poppins, sans-serif;
}
._wrapper_h25l6_1 ._rightPart_h25l6_27 {
  text-align: right;
}
._wrapper_h25l6_1 ._rightPart_h25l6_27 ._amount_h25l6_30 {
  font-weight: 600;
  font-size: 18px;
  color: #6549f0;
}

._canceled_h25l6_36 {
  opacity: 0.7;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  